import { render, staticRenderFns } from "./BusinessNameDataUpdateTaskLevel2.vue?vue&type=template&id=66c3e062&scoped=true&"
import script from "./BusinessNameDataUpdateTaskLevel2.vue?vue&type=script&lang=js&"
export * from "./BusinessNameDataUpdateTaskLevel2.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameDataUpdateTaskLevel2.vue?vue&type=style&index=0&id=66c3e062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c3e062",
  null
  
)

export default component.exports